// Multi-currency display helpers. Base amounts are stored in INR.
const USD_INR = 83.0;

export const CURRENCY_SYMBOLS = { INR: "\u20B9", USD: "$" };

export function convert(amountInr, currency) {
  if (currency === "USD") return amountInr / USD_INR;
  return amountInr;
}

export function formatMoney(amountInr, currency = "INR", compact = false) {
  const val = convert(amountInr || 0, currency);
  const symbol = CURRENCY_SYMBOLS[currency] || "\u20B9";
  if (compact && Math.abs(val) >= 1000) {
    const locale = currency === "INR" ? "en-IN" : "en-US";
    const opts = { notation: "compact", maximumFractionDigits: 1 };
    return symbol + new Intl.NumberFormat(locale, opts).format(val);
  }
  const locale = currency === "INR" ? "en-IN" : "en-US";
  return symbol + new Intl.NumberFormat(locale, { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(val);
}

export function formatDate(d) {
  if (!d) return "";
  try {
    return new Date(d).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return d;
  }
}
